import {Icon} from '@/app/components/Icon';
import {useMemo} from 'react';
import {Button} from '@/components/app/button';
import {cn} from '@/lib/utils';
import {BiobookPage} from './BiobookPage';
import {useDemo} from '../../demo/hooks/useDemo';
import styles from './BiobookPageLocked.module.css';
let idCount = 0;
export interface BiobookPageLockedProps {
  className?: string;
  userId: number;
}
export const BiobookPageLocked = ({className, userId}: BiobookPageLockedProps) => {
  const {showLimitReachedDialog} = useDemo();
  const phraseId = useMemo(() => --idCount, []);
  return (
    <div className={cn(className, 'relative')}>
      <BiobookPage
        biobookPage={{
          bodyLifeMapLabelNames: ['Locked'],
          bodyLifeMapLabelShowOrders: [1],
          fileNames: [],
          institutionLongNames: [''],
          institutionShortNames: [''],
          isDistantRelative: false,
          isStandardAndPolicy: false,
          managementLabelName: 'Act',
          managementLabelShowOrder: 1,
          matchedConditionIds: [],
          matchedConditionNames: ['Locked'],
          mechanismLabelColor: null,
          mechanismLabelName: 'Structural',
          mechanismLabelShowOrder: 1,
          moduleName: 'Locked Module',
          phraseBodyHtml: `Please sign up to unlock the rest of the information.`,
          phraseId,
          phraseTypeColor: 'cyan-400',
          phraseTypeName: 'Recommendation',
          sourcePublishDate: `${new Date().toISOString().slice(0, 10)}`,
          sourceTitle: 'Biotandem',
          sourceUrl: '/sign-up',
        }}
        className={styles.biobookPage}
        readOnly
        userId={userId}
      />
      <div className={styles.mask}>
        <div className={'text-green-600 text-center font-bold'}>
          Please sign up to unlock the rest of the information.
        </div>
        <Button
          onClick={() =>
            showLimitReachedDialog({
              message: 'Please sign up to unlock the rest of the information.',
              title: 'Unlock Biobook',
            })
          }
          variant="success"
          className="rounded-full"
          type="button"
          startIcon={<Icon icon={'lock-open'} />}
        >
          {'Unlock'}
        </Button>
      </div>
    </div>
  );
};
